export enum ButtonVariants {
  PRIMARY = "primary",
  SECONDARY = "secondary",
}

export enum ButtonTypes {
  BUTTON = "button",
  SUBMIT = "submit",
}

export interface IconProps {
  src: string;
  alt: string;
  iconDimension?: number;
}
